import React from 'react'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { TextField } from '@mui/material';
import { pt } from "date-fns/locale";

export default function DatePickerField(props) {

    const { name, label, value, dateFormat, onChange, ...other } = props

    const convertToDefEventPara = (name, value) => ({
        target: {
            name, value
        }
    })

    return (
        <LocalizationProvider locale={pt} dateAdapter={AdapterDateFns}>
        <DatePicker
            label={label}
            inputFormat={dateFormat || "yyyy/MM/dd"}
            name={name}
            autoFocus={false}
            value={value || null}
            autoOk={true}
            onChange={date => onChange(convertToDefEventPara(name, moment(date).format('YYYY-MM-DD')))}
            renderInput={(params) => <TextField {...params } fullWidth sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderRadius: 8,
                  },

                },
              }} size="small" />}
        />
    </LocalizationProvider>
    )
}
